<div class="chatbot-open-button"
     [class.mobileNavigationActive]="this.mobileNavigationService.isActive"
     *ngIf="this.chatService.isChatBotAvailable()"
     (click)="this.chatService.showChatbot()">
    <img ngSrc="assets/img/chatBot/gerd.png" alt="Gerd" fill="">
</div>
